const spinner = {
    state: {
        spinner: false
    },

    actions: {
        async A_SET_SPINNER ({ commit }, payload) {
            await commit('M_SET_SPINNER', payload)
        }
    },

    mutations: {
        M_SET_SPINNER (state, data) {
            state.spinner = data
        }
    },

    getters: {
        GET_SPINNER: (state) => {
            return state.spinner
        }
    }
}

export default spinner
